import { render, staticRenderFns } from "./questionBankAnalysis.vue?vue&type=template&id=18b6860c&scoped=true&"
import script from "./questionBankAnalysis.vue?vue&type=script&lang=js&"
export * from "./questionBankAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./questionBankAnalysis.vue?vue&type=style&index=0&id=18b6860c&lang=scss&scoped=true&"
import style1 from "./questionBankAnalysis.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6860c",
  null
  
)

export default component.exports